import { useState } from 'react';
import { View, TextField, Button, Alert, Text, useAuthenticator } from '@aws-amplify/ui-react';
import { useTranslation } from 'react-i18next';
import { resendSignUpCode } from 'aws-amplify/auth';
import I18nTextUtils from '../utils/i18n/I18nTextUtils';
import './CustomConfirmSignUp.css';

/**
 * Custom ConfirmSignUp component that adds a message about checking spam folder
 * This replaces the default ConfirmSignUp view in the Authenticator
 */
export function CustomConfirmSignUp() {
  const { t } = useTranslation();
  const { submitForm, updateForm, validationErrors, isPending, username } = useAuthenticator();
  const [isResending, setIsResending] = useState(false);

  const handleResendCode = async () => {
    if (!username) return;
    
    setIsResending(true);
    try {
      const currentLanguage = I18nTextUtils.getCurrentLanguage();
      console.log('[CustomConfirmSignUp] Resend code with language:', currentLanguage);
      console.log('[CustomConfirmSignUp] Username:', username);
      
      // Call resendSignUpCode with clientMetadata
      // If clientMetadata is not received by Lambda, the cache fallback will be used
      await resendSignUpCode({
        username,
        options: {
          clientMetadata: {
            language: currentLanguage,
          },
        },
      });
    } catch (error) {
      console.error('[CustomConfirmSignUp] Error resending code:', error);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <View className="custom-confirm-signup-container">
      <Alert variation="info" hasIcon className="spam-folder-alert">
        <Text className="spam-folder-alert-text">
          {t('user.check-spam-folder')}
        </Text>
      </Alert>
      <TextField
        label={t('user.email-confirmation-title')}
        name="confirmation_code"
        placeholder={t('user.email-confirmation-title')}
        onChange={(e) => updateForm({ confirmation_code: e.target.value })}
        errorMessage={validationErrors.confirmation_code}
        autoComplete="one-time-code"
      />
      <Button onClick={submitForm} isLoading={isPending} variation="primary">
        Confirm
      </Button>
      <Button 
        onClick={handleResendCode} 
        isLoading={isResending} 
        variation="link"
        className="resend-code-button"
      >
        {t('user.resend-code') || 'Resend Code'}
      </Button>
    </View>
  );
}
